import React, { useState, useEffect } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import CustomDateRangePicker from "../CustomDateRangePicker";
import Select from "react-select";
import DateTime from "react-datetime";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { stringIsNullOrEmpty } from "../../util/Util";
import { LanguageKey } from "../../util/Constant";
import { useTranslation } from "react-i18next";
import moment from "moment";

const FilterInput = (props) => {
    const {
        fieldType, // input, AsyncPaginate, DateRangePicker, Select, DateTime
        type,
        name,
        value,
        onChange,
        placeholder,
        debounceTimeout,
        options,
        additional,
        label,
        alwaysShowCalendars,
        onApply,
        onCancel,
        ranges,
        isMulti,
        startDate,
        endDate,
        locale,
        timePicker,
        timePickerSeconds,
        readOnly,
        isDisabled=false,
        maxDate,
        singleDatePicker,
        minDate,
        ref,
        inputProps,
        closeOnSelect,
        dateFormat,
        timeFormat,
        textLimit=0,
        canClear,
        style,
        ...rest
    } = props;

    const { t } = useTranslation(LanguageKey._PRIMARY);
    const [tooltipText] = useState(
        t("TEXT_LIMIT_TOOLTIP", { textLimit }) // Pass textLimit as a parameter to the translation function
    );
    const [displayToolTip, setDisplayToolTip] = useState(false);
    const [tempData,setTempData]=useState(false);
    const [selectedVal,setSelectedVal]=useState(null);
    const [isOpen, setOpen] = useState(false);
    const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);

    

    useEffect(()=>{
        const defaultDate =  moment().format("YYYY-MM-DD");// current moment object

        const start =  singleDatePicker
        ? (stringIsNullOrEmpty(value) ? defaultDate : value)
        : (stringIsNullOrEmpty(startDate) ? defaultDate :startDate);
      
        const end = singleDatePicker
        ? (stringIsNullOrEmpty(value) ? defaultDate : value)
        : (stringIsNullOrEmpty(endDate) ? defaultDate : endDate);

        setStartDateValue(start)
        setEndDateValue(end)

    },[startDate,endDate])
    const handleFocusOnAsyncPaginate = (selectedOption) => {
        if(textLimit > 0 && selectedOption){
		    setDisplayToolTip(selectedOption.length > 0 && selectedOption.length < textLimit);
        }

        if(stringIsNullOrEmpty(selectedOption)){
            setDisplayToolTip(true);
        }
	};

    const handleBlurOnAsyncPaginate = () => {
        setDisplayToolTip(false);
    };

    useEffect(() => {
        if (tempData) {
            setDisplayToolTip(false);
            setTempData(false);
        }
    }, [tempData]);

    const handleChange = (selectedValue) => {
        if (selectedValue) {
            setTempData(true);
            setSelectedVal(selectedValue);

            if (typeof onChange === "function") { 
                onChange(selectedValue);
            }
        }
    };

    return (
		<>
           {fieldType == "Input" && (
                <>
                    <div className={props.className || "form-group mb-3"}>
                        {label &&(
                            <label>
                                <b>{label}</b>
                            </label>
                        )}
                        <input
                            type={type}
                            className="form-control"
                            name={name}
                            value={value || ""}
                            onChange={onChange}
                            placeholder={placeholder}
                            readOnly={readOnly}
                            ref={ref}
                        />
                    </div>
                </>
           )}

           {fieldType == "Select" && (
                <>
                    <div className="form-group mb-3 filter-select">
                       { !stringIsNullOrEmpty(label) && (<label>
                            <b>{label}</b>
                        </label>)}
                        <div
                className="input-group"
                style={{ flexFlow: "nowrap" }}
                        >
                            <div
                                className="input-group-append"
                                style={{ width: "100%" }}
                            >
                                <Select
                                    styles={{
                                        container: () => ({
                                            width: "100%",
                                        }),
                                    }}
                                    name={name}
                                    value={value}
                                    options={options}
                                    isMulti = {isMulti}
                                    onChange={onChange}
                                    placeholder={placeholder}
                                />
                            </div>
                        </div>
                    </div>
                </>
           )}

           {fieldType == "AsyncPaginate" && (
          <>
            <div className={props.className || "form-group mb-3 filter-asyncpaginate"} >
                      {!stringIsNullOrEmpty(label) ?
                        <label>
                          <b>{label}</b>
                        </label>
                        : ""}
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>{tooltipText}</Tooltip>}
                          show={displayToolTip}
                        >
                        <div className="async-paginate" 
                            onClick={(e) => handleFocusOnAsyncPaginate()}
                            onBlur={handleBlurOnAsyncPaginate}
                        >
                            {
                            <AsyncPaginate
                                placeholder={isOpen?"":placeholder}
                                debounceTimeout={debounceTimeout}
                                loadOptions={options}
                                additional={additional}
                                value={value}
                                onChange={handleChange}
                                isDisabled={isDisabled}
                                onInputChange={handleFocusOnAsyncPaginate}
                                onMenuOpen={() => {
                                    //onChange({label:"",value:""});
                                    setOpen(true);
                                }}
                                onMenuClose={() => {
                                    // onChange(selectedVal?.label?{label:selectedVal?.label,value:selectedVal?.value}:
                                    //     {label:"",value:""}
                                    // );
                                    setOpen(false);
                                }}
                            />
                            }                
                      </div>
                      </OverlayTrigger>									                          
                    </div>
                </>
           )}

           {fieldType == "DateTime" && (
                <>
                    <div className="form-group mb-3">
                        <label>
                            <b>{label}</b>
                        </label>
                        <div className="async-paginate">
                            {
                                 <DateTime
                                    timeFormat={timeFormat}
                                    dateFormat={dateFormat}
                                    value={value}
                                    closeOnSelect={closeOnSelect}
                                    inputProps={inputProps}
                                    onChange={onChange}
                                />
                            }
                        </div>
                    </div>
                </>
           )}

            {fieldType == "DateRangePicker" && (
                <>
                    <div className="form-group mb-3 date-range-picker">
                        <label>
                            <b>{label}</b>
                        </label>
                        <div
                            className="input-group"
                            style={{ width: "100%", flexFlow: "nowrap" }}
                        >
                            <div
                                className="input-group-append"
                                style={{ width: "100%" }}
                            >
                                <CustomDateRangePicker
                                    containerStyles={{ width: "100%" }}
                                    // value={startDate + " - " + endDate}
                                    // startDate={
                                    //     moment(
                                    //         stringIsNullOrEmpty(startDate) ? moment().format("YYYY-MM-DD") : startDate
                                    //         // singleDatePicker 
                                    //         // ? (stringIsNullOrEmpty(value) ? moment().format("YYYY-MM-DD") : value)
                                    //         // : (stringIsNullOrEmpty(startDate) ? moment().format("YYYY-MM-DD") : startDate)
                                    //     )
                                    // }
									// endDate={
                                    //     moment(
                                    //         stringIsNullOrEmpty(endDate) ? moment().format("YYYY-MM-DD") : endDate
                                    //         // singleDatePicker 
                                    //         // ? (stringIsNullOrEmpty(value) ? moment().format("YYYY-MM-DD") : value)
                                    //         // : (stringIsNullOrEmpty(endDate) ? moment().format("YYYY-MM-DD") : endDate)
                                    //     )
                                    // }
                                    startDate={startDateValue}
                                    endDate={endDateValue}
									onApply={onApply}
                                    onCancel={onCancel}
									alwaysShowCalendars={alwaysShowCalendars}
									locale={locale}
									timePicker={timePicker}
									timePickerSeconds={timePickerSeconds}
									ranges={ranges}
									minDate={minDate}
									maxDate={maxDate}
									singleDatePicker={singleDatePicker}
                                    canClear={canClear}
                                >
                                    <>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={placeholder}
                                            value={value}
                                            onChange={handleChange}
                                            disabled={isDisabled}
                                        />
                                        {/*<div className="calendar-icon">
                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M4.75 1.5C4.75 1.08579 4.41421 0.75 4 0.75C3.58579 0.75 3.25 1.08579 3.25 1.5V1.90665C3.00413 1.96421 2.77128 2.04472 2.54754 2.15873C1.84193 2.51825 1.26825 3.09193 0.908726 3.79754C0.682385 4.24175 0.588026 4.7219 0.543364 5.26853C0.499987 5.79944 0.499993 6.45505 0.5 7.26789V8.73211C0.499993 9.54494 0.499987 10.2006 0.543364 10.7315C0.588026 11.2781 0.682385 11.7582 0.908726 12.2025C1.26825 12.9081 1.84193 13.4817 2.54754 13.8413C2.99175 14.0676 3.4719 14.162 4.01853 14.2066C4.54944 14.25 5.20505 14.25 6.01788 14.25L9.40133 14.25C9.72358 14.25 9.94299 14.2501 10.1364 14.23C11.9018 14.0472 13.2972 12.6518 13.48 10.8864C13.5001 10.693 13.5 10.4736 13.5 10.1514L13.5 7.26788C13.5 6.45505 13.5 5.79944 13.4566 5.26853C13.412 4.7219 13.3176 4.24175 13.0913 3.79754C12.7317 3.09193 12.1581 2.51825 11.4525 2.15873C11.2287 2.04472 10.9959 1.96421 10.75 1.90665V1.5C10.75 1.08579 10.4142 0.75 10 0.75C9.58579 0.75 9.25 1.08579 9.25 1.5V1.75859C8.87652 1.74999 8.45604 1.75 7.98211 1.75H6.0179C5.54396 1.75 5.12348 1.74999 4.75 1.75859V1.5ZM3.22852 3.49524C3.42604 3.3946 3.68681 3.32547 4.14068 3.28838C4.60331 3.25058 5.19755 3.25 6.05 3.25H7.95C8.80245 3.25 9.39669 3.25058 9.85932 3.28838C10.3132 3.32547 10.574 3.3946 10.7715 3.49524C11.1948 3.71095 11.5391 4.05516 11.7548 4.47852C11.8554 4.67604 11.9245 4.9368 11.9616 5.39068C11.9764 5.57123 11.9855 5.77183 11.991 6H2.00895C2.01455 5.77183 2.02363 5.57123 2.03838 5.39068C2.07547 4.9368 2.1446 4.67604 2.24524 4.47852C2.46095 4.05516 2.80516 3.71095 3.22852 3.49524ZM2 7.5V8.7C2 9.55245 2.00058 10.1467 2.03838 10.6093C2.07547 11.0632 2.1446 11.324 2.24524 11.5215C2.46095 11.9448 2.80516 12.289 3.22852 12.5048C3.42604 12.6054 3.68681 12.6745 4.14068 12.7116C4.60331 12.7494 5.19755 12.75 6.05 12.75H9.35571C9.74066 12.75 9.87595 12.749 9.98184 12.738C11.0411 12.6283 11.8783 11.7911 11.988 10.7318C11.999 10.6259 12 10.4907 12 10.1057V7.5H2Z" fill="#AAAAAA" />
                                            </svg>
                                        </div>*/}
                                    </>
                                </CustomDateRangePicker>
                            </div>
                        </div>
                    </div>
                </>
           )}
        </>
    );
};

export default FilterInput;